/**
 * LIFF config: LIFF IDs per shop, host-to-shop mapping, redirect rules.
 */

/** Map shop name → LIFF ID from env vars. */
export const LIFF_IDS = {
  smile: process.env.REACT_APP_LIFF_ID_SMILE,
  tama: process.env.REACT_APP_LIFF_ID_TAMA,
};

/** Hostname → shop (used by LiffApp to infer shop from domain). After adding a new host (e.g. staging), redeploy so the change is live. */
export const HOST_TO_SHOP = {
  'tama-chan.com': 'tama',
  'www.tama-chan.com': 'tama',
  'smile-nsg.co.th': 'smile',
  'www.smile-nsg.co.th': 'smile',
  // Staging (Vercel) – after LINE login redirect we lose ?shop=, infer from host
  'smile-shipping-front-git-staging-gain-team.vercel.app': 'smile',
};

/** For ShopDomainRedirect: when user hits "/" on these hosts, redirect to /liff. */
export const SHOP_DOMAIN_MAP = [
  { hosts: ['tama-chan.com', 'www.tama-chan.com'], shop: 'tama' },
  { hosts: ['smile-nsg.co.th', 'www.smile-nsg.co.th'], shop: 'smile' },
  { hosts: ['smile-shipping-front-git-staging-gain-team.vercel.app'], shop: 'smile' },
];

export const getLiffIdForShop = (shop) => {
  const liffId = LIFF_IDS[shop?.toLowerCase()];
  if (!liffId) {
    throw new Error(`ไม่พบการตั้งค่า LIFF สำหรับร้าน: ${shop}`);
  }
  return liffId;
};

export const getShopFromHostname = () => {
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  return HOST_TO_SHOP[host] || null;
};
